import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { FusionClient, FusionConfig, FusionFactory, InMemoryCache, SyncCache } from '@ssi/fusion';
import { BrowserStorage, BrowserLocation, BrowserWindow } from './app.models';
import { AuthTokenService } from './services/auth-token.service';
import { Environment } from './app.constants';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    { provide: BrowserStorage, useValue: window.localStorage },
    { provide: BrowserLocation, useValue: window.location },
    { provide: BrowserWindow, useValue: window },
    {
      provide: FusionClient,
      useFactory: (authTokenService: AuthTokenService) => {
        const config: FusionConfig = {
          application: 'fusion-web',
          environment: Environment,
          getIdTokenFn: () => {
            const altTokenKey = 'cognito_alt_token';
            const altToken = localStorage.getItem(altTokenKey);
            if (!altToken) {
              localStorage.setItem(altTokenKey, '');
            }
            return altToken ? Promise.resolve(altToken) : authTokenService.getIdToken();
          }
        };
        const factory = new FusionFactory(config);
        return factory.buildFusionClient();
      },
      deps: [AuthTokenService]
    },
    {
      provide: SyncCache,
      useValue: new InMemoryCache()
    }
  ]
};
